import type {
  FsV1Data,
  FsV2DataCampaign,
  FsV2DataSpot,
} from '../models/firestore-data.model';

/**
 * FsV1Data型のデータかどうかを判定する型ガード関数
 * @param data 判定対象のデータ
 * @returns FsV1Data型の場合はtrue
 */
export function isFsV1Data(data: unknown): data is FsV1Data {
  try {
    return (
      data !== null &&
      typeof data === 'object' &&
      'allarea' in data &&
      typeof (data as any).allarea === 'object' &&
      'pv' in (data as any).allarea
    );
  } catch {
    return false;
  }
}

/**
 * FsV2DataCampaign型の配列かどうかを判定する型ガード関数
 * @param data 判定対象のデータ
 * @returns FsV2DataCampaign[]型の場合はtrue
 */
export function isFsV2DataCampaign(data: unknown): data is FsV2DataCampaign[] {
  try {
    return (
      Array.isArray(data) &&
      data.length > 0 &&
      typeof data[0] === 'object' &&
      'allarea' in data[0] &&
      Array.isArray((data[0] as any).allarea) &&
      (data[0] as any).allarea.length > 0 &&
      'cp' in (data[0] as any).allarea[0]
    );
  } catch {
    return false;
  }
}

/**
 * FsV2DataSpot型の配列かどうかを判定する型ガード関数
 * @param data 判定対象のデータ
 * @returns FsV2DataSpot[]型の場合はtrue
 */
export function isFsV2DataSpot(data: unknown): data is FsV2DataSpot[] {
  try {
    return (
      Array.isArray(data) &&
      data.length > 0 &&
      typeof data[0] === 'object' &&
      'allarea' in data[0] &&
      Array.isArray((data[0] as any).allarea) &&
      (data[0] as any).allarea.length > 0 &&
      'sv' in (data[0] as any).allarea[0]
    );
  } catch {
    return false;
  }
}
